import { render, staticRenderFns } from "./InternationalCallsChanges.vue?vue&type=template&id=016fdf5b&scoped=true&"
import script from "./InternationalCallsChanges.vue?vue&type=script&lang=js&"
export * from "./InternationalCallsChanges.vue?vue&type=script&lang=js&"
import style0 from "./InternationalCallsChanges.vue?vue&type=style&index=0&id=016fdf5b&prod&lang=scss&scoped=true&"
import style1 from "./InternationalCallsChanges.vue?vue&type=style&index=1&id=016fdf5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016fdf5b",
  null
  
)

export default component.exports